module.exports = __webpack_public_path__ + "img/icon_ticket.da125f3c.png";